<template>
  <div
    id="search-date-picker"
    class="d-flex-center"
    style="min-width: 102px;"
  >
    <slot name="icon" />
    <flat-pickr
      id="flat-pickr-date"
      ref="flatPickrRef"
      :value="dateValue"
      class="form-control text-body font-weight-bold text-subtitle"
      style="min-width: 200px"
      :config="{
        dateFormat: 'Y-m-d',
        allowInput: true,
        altInput: true,
        altFormat: 'd-m-Y',
        locale: this.$i18n.locale === 'vi' ? Vietnamese : null,
        shorthandCurrentMonth: true,
        disableMobile: true,
        ...config
      }"
      :events="['onDayCreate', 'onOpen', 'onMonthChange']"
      placeholder="Chọn ngày"
      @input="val => handleChange(val)"
      @on-day-create="listenToOnDayCreateEvent"
    />
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { toRefs } from '@vue/composition-api'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import 'flatpickr/dist/themes/airbnb.css'
import { LunarDate } from 'vietnamese-lunar-calendar'

import { specialDayOfVietnam } from '@/constants/selectOptions'
import { convertISODateTime } from '@/@core/utils/filter'

import useToast from '@useToast'

export default {
  components: {
    flatPickr,
  },
  props: {
    date: {
      type: [String, Date],
      default: '',
    },
    config: {
      type: Object,
      default: () => { },
    },
  },
  setup(props, { emit }) {
    const { toastError } = useToast()

    const dateValue = toRefs(props).date
    function handleChange(val) {
      const chooseDate = val
      const dateProp = convertISODateTime(new Date(dateValue.value)).dateFilter
      if (!chooseDate) {
        toastError('messagesList["Invalid date, please try again"]')
      }
      if (chooseDate && dateProp !== chooseDate) {
        emit('update:date', chooseDate)
        emit('input', chooseDate)
      }
    }

    function listenToOnDayCreateEvent(...val) {
      const solarDate = {
        year: new Date(val[3].dateObj).getFullYear(),
        month: new Date(val[3].dateObj).getMonth() + 1,
        day: new Date(val[3].dateObj).getDate(),
      }
      const nowDay = Number(val[2].now.getDate())
      const nowMonth = Number(val[2].now.getMonth()) + 1
      const currentMonth = val[2].currentMonth + 1
      const lunarDate = new LunarDate(solarDate.year, solarDate.month, solarDate.day)
      const oldValue = val[3].innerHTML
      const isSpecialDay = specialDayOfVietnam.find(item => {
        if (item.type === 'solar') {
          return item.date === Number(solarDate.day) && item.month === Number(solarDate.month)
        }
        if (item.type === 'lunar') {
          return item.date === lunarDate?.date && item.month === lunarDate?.month
        }
        return false
      })

      val[3].innerHTML = `
      <div class="${solarDate.month !== currentMonth || (solarDate.day < nowDay && solarDate.month === nowMonth) ? 'opacity-50' : ''}">
        <div class="day-value ${isSpecialDay ? 'text-danger' : ''}">${oldValue}</div>
        <div style="
          font-size: 10px;
          display: block;
          position: absolute;
          bottom: -10px;
          right: 4px;
          ${lunarDate.date === 1 || ((Number(oldValue) === 1 && Number(solarDate.month) === currentMonth)) || isSpecialDay ? 'color: red' : ''}"
        >${lunarDate.date}${lunarDate.date === 1 || (Number(oldValue) === 1 && Number(solarDate.month) === currentMonth) || isSpecialDay ? `/${lunarDate.month}` : ''}</div>
      </div>
      `
    }

    return {
      listenToOnDayCreateEvent,
      handleChange,
      dateValue,
      Vietnamese,
    }
  },
}

</script>

<style lang="scss">
span.flatpickr-day {
  height: 45px;

  .day-value {
    transform: translate(2px, -2px);
    font-size: 20px
  }
}

.flatpickr-calendar .flatpickr-day.selected,
.flatpickr-calendar .flatpickr-day.selected:hover {
  border-radius: 4px !important;
}

span.flatpickr-day.today:not(.selected),
span.flatpickr-day.prevMonthDay.today:not(.selected),
span.flatpickr-day.nextMonthDay.today:not(.selected) {
  border-bottom-color: #3DA5DE;

}

span.flatpickr-day.today:not(.selected):hover,
span.flatpickr-day.prevMonthDay.today:not(.selected):hover,
span.flatpickr-day.nextMonthDay.today:not(.selected):hover {
  border-color: #3DA5DE;
}
</style>
